import styled from '@emotion/styled';
import { Divider, Grid } from '@mui/material';
import React from 'react'
import ContentEditable from 'react-contenteditable';
import { COLOR_MAP } from '../../../../constants/ColorNames';

const Placeholder = styled.span`
  margin: 0;
  position: absolute;
  top: 4.72rem;
  pointer-events: none;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${COLOR_MAP.GREY_4};
`

const PlacholderLink = styled.span`
  color: ${COLOR_MAP.PRIMARY};
`

type EmailFooterProps = {
  signatureRef:any;
  // jdRef: any;
  handleContentChange: (event: React.BaseSyntheticEvent, element: string ) => void;
  signatureContent: string;
  jdContent : string;
  setElement:(element: string) => void
}

type  EditorProps = {
  handleChange: (event: React.BaseSyntheticEvent, element: string) => void,
  content: string,
  setElement: () => void,
  type : string,
  headerText: string,
  showPlaceholder?: boolean
}

const Container = styled(Grid)`
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 2.4rem;
    min-height: 8rem;
   
`;

export type Ref = React.MutableRefObject<HTMLInputElement>;
const  Editor = React.forwardRef<HTMLInputElement,  EditorProps>((props, ref) => {
const { content,  handleChange, setElement, type, headerText, showPlaceholder} = props; 

  return (
    <Container item padding='2rem 1.4rem' sx={{position: 'relative'}}>
      <Divider
      sx={{
        color: COLOR_MAP.GREY_1,
        "&:: before": {
          borderTop: `dashed ${COLOR_MAP.GREY_1} !important`,
          borderWidth: '0.1rem !important'
        },
        "&:: after": {
          borderTop: `dashed ${COLOR_MAP.GREY_1} !important`,
          borderWidth: '0.1rem !important'
        },
      }}
      textAlign="left">{headerText}</Divider>
    <ContentEditable
      style={{
        width: '100%',
        outline: 'none',
        height: '100%',
      }}
    innerRef={ref!}
    html={content}
    disabled={false}
    onChange={(e: React.BaseSyntheticEvent) => handleChange(e,type)}
    onClick={setElement}
    onFocus={setElement}
    onBlur={()=>null}
/>
{(!content && showPlaceholder) ? <Placeholder onClick={setElement} onFocus={setElement}>Example: <PlacholderLink>https://www.foundit.in/srp/results?query=xSP_genptinx,xgenpactindinxro</PlacholderLink></Placeholder> : null} 
</Container>
  )
})

const EmailFooter = (props:EmailFooterProps) => {
  const { signatureRef, handleContentChange, signatureContent, jdContent, setElement} = props;
  return (
    <Grid container flexWrap={'nowrap'}>
      <Grid item xs={12}>
      <Editor headerText='Signature' type ='signature' ref={signatureRef} handleChange = {handleContentChange} content={signatureContent} setElement={() =>setElement('signature')}/>
      </Grid>
    
      {/* <Grid item xs={0.1} sx={{paddingTop:'4rem', paddingBottom: '1rem'}}>
      <Divider    orientation="vertical" sx={{color: COLOR_MAP.GREY_1,  height: '98%',}}></Divider>
      </Grid>
      <Grid item xs={7}>
      <Editor showPlaceholder={true} headerText='Include job descriptions link below for better conversion' type ='jd' ref={jdRef} handleChange = {handleContentChange} content={jdContent} setElement={() =>setElement('jd')}/>
      </Grid> */}
    </Grid>
  )
}

export default EmailFooter;